export default function Tab2() {
  return <div> Multiple days </div>;
}
